import { render, staticRenderFns } from "./DropdownMyCart.vue?vue&type=template&id=3d4a307e&"
import script from "./DropdownMyCart.vue?vue&type=script&lang=js&"
export * from "./DropdownMyCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports